import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

/**
 * Breadcrumb + title + subtitle + right-aligned actions, with the
 * bottom hairline that separates the head from the toolbar/table below.
 */
function PageHead({ breadcrumb, title, subtitle, actions }) {
	return (
		<div className='tw:flex tw:items-end tw:justify-between tw:gap-5 tw:pb-5 tw:mb-6 tw:border-b tw:border-border'>
			<div>
				{breadcrumb && breadcrumb.length > 0 && (
					<nav className='tw:m-0 tw:text-[12.5px] tw:text-ink-3'>
						{breadcrumb.map((crumb, index) => {
							const isLast = index === breadcrumb.length - 1;
							return (
								<span key={crumb.label}>
									{index > 0 && <span className='tw:mx-1.5'>/</span>}
									{isLast || !crumb.to ? (
										<span className={isLast ? 'tw:text-ink-0 tw:font-medium' : 'tw:text-ink-2'}>
											{crumb.label}
										</span>
									) : (
										<Link to={crumb.to} className='tw:text-ink-2 tw:no-underline tw:hover:text-accent'>
											{crumb.label}
										</Link>
									)}
								</span>
							);
						})}
					</nav>
				)}
				<h1 className='tw:mt-2 tw:mb-0 tw:text-[28px] tw:font-bold tw:tracking-[-0.02em] tw:text-ink-0'>
					{title}
				</h1>
				{subtitle && <p className='tw:mt-1 tw:mb-0 tw:text-[13.5px] tw:text-ink-2'>{subtitle}</p>}
			</div>
			{actions && <div className='tw:flex tw:gap-2 tw:shrink-0'>{actions}</div>}
		</div>
	);
}

PageHead.propTypes = {
	breadcrumb: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string.isRequired,
			to: PropTypes.string,
		}),
	),
	title: PropTypes.node.isRequired,
	subtitle: PropTypes.node,
	actions: PropTypes.node,
};

export default PageHead;
